import { render, staticRenderFns } from "./certificate1.vue?vue&type=template&id=cf7a28fc&scoped=true"
import script from "./certificate1.vue?vue&type=script&lang=js"
export * from "./certificate1.vue?vue&type=script&lang=js"
import style0 from "./certificate1.vue?vue&type=style&index=0&id=cf7a28fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7a28fc",
  null
  
)

export default component.exports